// Adorans is mirrored from Hosanna. Other legacy workspaces remain editable.
export const ADORANS_WORKSPACE_ID = 'songs-storage-3a7ae6b35a8362d28e342f9e';
export const isWorkspaceReadOnly = workspaceId => process.env.REACT_APP_HOSANNA_DIRECT === '1'
  ? workspaceId !== ADORANS_WORKSPACE_ID
  : process.env.REACT_APP_HOSANNA_READONLY === '1' || workspaceId === ADORANS_WORKSPACE_ID;

export const assertWorkspaceWritable = workspaceId => {
  if (isWorkspaceReadOnly(workspaceId)) {
    throw new Error('Workspace jest tylko do odczytu');
  }
};
